import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import { FieldDataValue } from 'embed/constants'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
  handleVehicleIdTypeChangeHandler: (value: FieldDataValue) => void
}

export const StepbystepApplicationStepVehicleIdType: React.FC<Props> = (props) => {
  const { handleVehicleIdTypeChangeHandler } = props

  return (
    <Wrapper {...props}>
      <StepTitle>How would you like to provide details about your vehicle?</StepTitle>
      <ApplicationField
        onChange={handleVehicleIdTypeChangeHandler}
        product={Product.Loan}
        field={Fields.VehicleIdType}
      />
    </Wrapper>
  )
}
